<template>
  <div class="container pt-5">
    <div class="row">
      <div class="col-lg-6">
        <div v-if="$i18n.locale === 'pl'">
          <h1 class="text-lg bold mb-4">Gdzie kupić produkty Nissens</h1>
          <div class="text-md">
            <p>
              Produkty Nissens dostępne są poprzez sieć wiodących dystrybutorów samochodowych
              części zamiennych na całym świecie, w tym w Polsce.  Aby uzyskać więcej informacji,
              prosimy o kontakt z lokalnym biurem handlowym Nissens. Dane kontaktowe na stronie
              <a href="https://nissens.com/en-gb/contact.aspx" target="_blank">www.nissens.com/contact</a>
            </p>
            <p>
              Więcej informacji na temat produktów Nissens znajdziecie Państwo na stronie internetowej
              <a href="https://nissens.com/" target="_blank">www.nissens.com</a>
            </p>
          </div>
        </div>
        <div v-else-if="$i18n.locale === 'it'">
          <h1 class="text-lg bold mb-4">Dove acquistare il prodotto Nissens</h1>
          <div class="text-md">
            <p>
              I prodotti Nissens sono disponibili presso i principali distributori di ricambi
              automobilistici del mercato in tutto il mondo. Per ulteriori informazioni, contattare
              la rispettiva filiale Nissens. Per trovare i dettagli di contatto, visitare
              <a href="https://nissens.com/en-gb/contact.aspx" target="_blank">www.nissens.com/contact</a>
            </p>
            <p>
              Per ulteriori informazioni sui prodotti Nissens, visitare il nostro sito Web all'indirizzo
              <a href="https://nissens.com/" target="_blank">www.nissens.com</a>
            </p>
          </div>
        </div>
        <div v-else-if="$i18n.locale === 'de'">
          <h1 class="text-lg bold mb-4">Wo kann man Nissens-Produkte kaufen?</h1>
          <div class="text-md">
            <p>
              Nissens Produkte sind weltweit erhältlich bei den marktführenden
              Ersatzteilvertriebshändlern. Wenden Sie sich für weitere Informationen
              an die jeweilige Nissens-Niederlassung oder den regionalen Verkaufsleiter.
              Kontaktinformationen finden Sie unter
              <a href="https://nissens.com/en-gb/contact.aspx" target="_blank">www.nissens.com/contact</a>
            </p>
            <p>
              Für weitere Informationen zu Nissens Produkten besuchen sie unsere Webseite
              <a href="https://nissens.com/" target="_blank">www.nissens.com</a>
            </p>
          </div>
        </div>
        <div v-else-if="$i18n.locale === 'fr'">
          <h1 class="text-lg bold mb-4">Où acheter les produits Nissens</h1>
          <div class="text-md">
            <p>
              Les produits Nissens sont disponibles chez les principaux distributeurs de
              pièces détachées automobiles du marché dans le monde entier. Contactez la
              filiale ou le directeur régional des ventes de Nissens pour plus d'informations.
              Pour trouver nos coordonnées, visitez
              <a href="https://nissens.com/en-gb/contact.aspx" target="_blank">www.nissens.com/contact</a>
            </p>
            <p>
              Pour plus d'informations sur les produits Nissens, visitez notre site Web à l'adresse
              <a href="https://nissens.com/" target="_blank">www.nissens.com</a>
            </p>
          </div>
        </div>
        <div v-else-if="$i18n.locale === 'fi'">
          <h1 class="text-lg bold mb-4">Mistä voit ostaa Nissens tuotteita</h1>
          <div class="text-md">
            <p>
              Nissensin tuotteita on saatavilla markkinoiden johtavilta autojen varaosien jälleenmyyjiltä
              maailmanlaajuisesti. Ota yhteyttä vastaavaan Nissensin tytäryhtiöön tai alueelliseen
              myyntipäällikköön saadaksesi lisätietoja. Löydät yhteystiedot osoitteesta
              <a href="https://nissens.com/en-gb/contact.aspx" target="_blank">www.nissens.com/contact</a>
            </p>
            <p>
              Lisätietoja Nissens-tuotteista on saatavilla verkkosivuiltamme osoitteessa
              <a href="https://nissens.com/" target="_blank">www.nissens.com</a>
            </p>
          </div>
        </div>
        <div v-else-if="$i18n.locale === 'ru'">
          <h1 class="text-lg bold mb-4">Где купить продукцию Nissens</h1>
          <div class="text-md">
            <p>
              Продукция Nissens доступна у ведущих дистрибьюторов автомобильных запчастей по всему миру.
              За дополнительной информацией обращайтесь в соответствующее дочернее предприятие Nissens
              или к региональному менеджеру по продажам. Чтобы найти контактную информацию, посетите сайт
              <a href="https://nissens.com/en-gb/contact.aspx" target="_blank">www.nissens.com/contact</a>
            </p>
            <p>
              Для получения дополнительной информации о продукции Nissens посетите наш сайт
              <a href="https://nissens.com/" target="_blank">www.nissens.com</a>
            </p>
          </div>
        </div>
        <div v-else-if="$i18n.locale === 'cz'">
          <h1 class="text-lg bold mb-4">Kde koupit produkt Nissens</h1>
          <div class="text-md">
            <p>
              Produkty Nissens jsou dostupné u předních světových distributorů automobilových náhradních
              dílů. Pro další informace kontaktujte příslušnou pobočku Nissens nebo regionálního manažera
              prodeje. Kontaktní údaje najdete na
              <a href="https://nissens.com/en-gb/contact.aspx" target="_blank">www.nissens.com/contact</a>
            </p>
            <p>
              Pro další informace o produktech Nissens navštivte naši webovou stránku
              <a href="https://nissens.com/" target="_blank">www.nissens.com</a>
            </p>
          </div>
        </div>
        <div v-else>
          <h1 class="text-lg bold mb-4">Where to buy Nissens product</h1>
          <div class="text-md">
            <p>
              Nissens products are available at the market's leading automotive spare parts
              distributors worldwide. Contact the respective Nissens subsidiary or regional
              sales manager for further information. To find contact details,
              visit <a href="https://nissens.com/en-gb/contact.aspx" target="_blank">www.nissens.com/contact</a>
            </p>
            <p>
              For further information about Nissens products, visit our website at
              <a href="https://nissens.com/" target="_blank">www.nissens.com</a>
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <img src="@/assets/Products_Portrait_White_500px.jpg" class="img-fluid">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo() {
    return {
      title: `${this.$t('menu.whereToBuy')} - Nissens Support`,
    };
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
a {
  color: $secondary;
}
</style>
